export default "__VITE_ASSET__d9cbba5d__"